import React from 'react';
import PropTypes from 'prop-types';

import { get } from 'helpers/api';
export default class PushStatus extends React.Component {
  static propTypes = {
    batch: PropTypes.object.isRequired
  }

  getStatus = () => {
    const { batch } = this.props;

    return get(batch.paths.pushContactsStatusPath).then(({ status }) => {
      if (status == "completed") {
        clearInterval(this.timer);
        location.reload();
      }
    });

  }
  componentDidMount() {
    this.timer = setInterval(() => this.getStatus(), 5000);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
    this.timer = null;
  }

  render() {
    return null;
  }
}
